module.exports = __webpack_public_path__ + "static/media/purple.6ade06ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/purple.svg
// module id = 76
// module chunks = 0